// Sera automatiquement remplacé lors de la création d'un tag "vX.X.X" par .github/workflows/tagToReleaseBranch.yml
export const AppVersion = 'v1.7.2'
